import { useState, useEffect } from 'react';

import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';

import CalenderImagePath from '../../../image/Calender-gray.png';
import CalenderRightArrowImagePath from '../../../image/CalenderRightArrow.png';
import CalenderLeftArrowImagePath from '../../../image/CalenderLeftArrow.png';
import WhiteCalenderRightArrowImagePath from '../../../image/WhiteCalenderRightArrow.png';
import WhiteCalenderLeftArrowImagePath from '../../../image/WhiteCalenderLeftArrow.png';
import CalenderLeftArrow2ImagePath from '../../../image/CalenderLeftArrow2.png';
import CalenderRightArrow2ImagePath from '../../../image/CalenderRightArrow2.png';

export default function CalenderModal(props) {
  const { startDate, setStartDate, endDate, setEndDate, onClickExitButton } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const leftArrowImage = isDark ? WhiteCalenderLeftArrowImagePath : CalenderLeftArrowImagePath;
  const rightArrowImage = isDark ? WhiteCalenderRightArrowImagePath : CalenderRightArrowImagePath;

  // 날짜 표시 포맷 //
  function formatMomentDate(m) {
    const y = String(m.year());
    const mo = String(m.month() + 1).padStart(2, '0');
    const d = String(m.date()).padStart(2, '0');
    const order = t('statistics.calendar.dateOrder');
    const sep = t('statistics.calendar.dateSeparator');

    if (order === 'MDY') return mo + sep + d + sep + y;
    return y + sep + mo + sep + d;
  }

  const [isFirst, setIsFirst] = useState(true);
  const [today, setToday] = useState(moment());
  const [startValue, setStartValue] = useState(startDate);
  const [endValue, setEndValue] = useState(endDate);

  const [startDateList, setStartDateList] = useState([]);
  const [endDateList, setEndDateList] = useState([]);
  const [compriseDateList, setCompriseList] = useState([]);
  const [clickCount, setClickCount] = useState(0);

  const startFirstWeek = today.clone().startOf('month').week();
  const startLastWeek = today.clone().endOf('month').week() === 1 ? 53 : today.clone().endOf('month').week();

  const endFirstWeek = today.clone().add(1, 'month').startOf('month').week();
  const endLastWeek = today.clone().add(1, 'month').endOf('month').week() === 1 ? 53 : today.clone().add(1, 'month').endOf('month').week();

  // 시작날짜 및 종료날짜 변경시 //
  useEffect(() => {
    setStartValue(startDate);
    setEndValue(endDate);
  }, [startDate, endDate])

  // 당월/익월 달력 날짜 목록 생성 //
  useEffect(() => {
    let newStartDateList = [];
    let newEndDateList = [];

    for (let week = startFirstWeek; week <= startLastWeek; week++) {
      for (let i = 0; i < 7; i++) {
        let days = today.clone().startOf('year').week(week).startOf('week').add(i, 'day');

        newStartDateList.push(days);
      }
    }

    for (let week = endFirstWeek; week <= endLastWeek; week++) {
      for (let i = 0; i < 7; i++) {
        let days = today.clone().add(1, 'month').startOf('year').week(week).startOf('week').add(i, 'day');

        newEndDateList.push(days);
      }
    }

    setStartDateList(newStartDateList);
    setEndDateList(newEndDateList);
  }, [today, startFirstWeek, startLastWeek, endFirstWeek, endLastWeek])

  // 선택 기간 포함 날짜 목록 계산 //
  useEffect(() => {
    if (startValue.format('YYYY-MM-DD') === '2000-01-01') return;

    if (startValue.format('YYYY-MM-DD') !== today.format('YYYY-MM-DD')
      && startValue.format('YYYY-MM-DD') !== '2000-01-01'
      && isFirst) {
      setToday(startValue);
      setIsFirst(false);
      return;
    }

    let newDateList = [];
    let calcDate = moment(startValue.clone().format('YYYY-MM-DDT23:59:59.99999'));

    while (calcDate < endValue.clone().add(1, 'day')) {
      newDateList.push(calcDate.format('YY.MM.DD'));
      calcDate = calcDate.add(1, 'day');
    }

    if (clickCount === 0) setClickCount(clickCount + 1);

    setCompriseList(newDateList);
  }, [startValue, endValue, today, clickCount, isFirst])

  function dateClick(division, index) {
    if (division === 'first') {
      if (clickCount === 0) {
        setStartValue(startDateList[index]);
        setClickCount(clickCount + 1);
      }
      else {
        if (startDateList[index].isAfter(moment())) {
          alert(t('statistics.calendar.alertOnlyToday'));
        }
        else if (startDateList[index].format('YYYY.MM.DD') < startValue.format('YYYY.MM.DD')) {
          setEndValue(startValue);
          setStartValue(startDateList[index]);
        }
        else {
          setEndValue(startDateList[index]);
        }
      }
    }
    else {
      if (clickCount === 0) {
        setStartValue(endDateList[index]);
        setClickCount(clickCount + 1);
      }
      else {
        if (endDateList[index].isAfter(moment())) {
          alert(t('statistics.calendar.alertOnlyTodayData'));
        }
        else if (endDateList[index].format('YYYY.MM.DD') < startValue.format('YYYY.MM.DD')) {
          setEndValue(startValue);
          setStartValue(endDateList[index]);
        }
        else {
          setEndValue(endDateList[index]);
        }
      }
    }
  }

  function onClickCalenderExit(division) {
    if (division === 'start') {
      setStartValue(moment('2000-01-01'));
      setEndValue(moment('2000-01-01'));
      setCompriseList([]);
      setClickCount(0);
    }
    else {
      setEndValue(moment('2000-01-01'));
    }
  }

  // 적용하기 버튼 클릭시 //
  function onClickSave() {
    setStartDate(moment(startValue.format('YYYY-MM-DDT00:00:00')));
    setEndDate(moment(endValue.format('YYYY-MM-DDT23:59:59.99999')));
    onClickExitButton();
  }

  return (
    <TotalModalWrapper>
      <Modal>
        <InnerWrapper>
          <TitleWrapper>
            <CustomText fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='pointer'>{t('statistics.calendar.settingTitle')}</CustomText>
          </TitleWrapper>
          <InfoWrapper>
            <CalenderWrapper>
              <InputWrapper>
                <Text>{t('statistics.calendar.startDate')}</Text>
                <Input img={CalenderImagePath}>
                  {formatMomentDate(startValue)}
                  {
                    startValue.format('YYYY.MM.DD') !== '2000.01.01' &&
                    <CalenderExit onClick={() => onClickCalenderExit('start')} />
                  }
                </Input>
              </InputWrapper>
              <CalenderView>
                <CalenderTitleWrapper>
                  <Arrow img={CalenderLeftArrow2ImagePath} onClick={() => setToday(today.clone().subtract(1, 'year'))} style={{ margin: `0 -7px 0 0` }} />
                  <Arrow img={leftArrowImage} onClick={() => setToday(today.clone().subtract(1, 'month'))} />
                  <Title>{today.format(t('statistics.dateFormatMonth'))}</Title>
                  <Arrow img={rightArrowImage} onClick={() => setToday(today.clone().add(1, 'month'))} />
                  <Arrow img={CalenderRightArrow2ImagePath} onClick={() => setToday(today.clone().add(1, 'year'))} style={{ margin: `0 0 0 -7px` }} />
                </CalenderTitleWrapper>
                <DateColumnWrapper>
                  <DateColumn style={{ width: `25px`, marginRight: `36px` }}>SUN</DateColumn>
                  <DateColumn style={{ width: `30px`, marginRight: `34px` }}>MON</DateColumn>
                  <DateColumn style={{ width: `23px`, marginRight: `36px` }}>TUE</DateColumn>
                  <DateColumn style={{ width: `28px`, marginRight: `35px` }}>WED</DateColumn>
                  <DateColumn style={{ width: `25px`, marginRight: `42px` }}>THU</DateColumn>
                  <DateColumn style={{ width: `18px`, marginRight: `40px` }}>FRI</DateColumn>
                  <DateColumn style={{ width: `24px`, marginRight: `28px` }}>SAT</DateColumn>
                </DateColumnWrapper>
                <TotalDateWrapper>
                  {
                    startDateList.map((data, index) => (
                      data.format('MM') === today.format('MM') ?
                        <DateWrapper key={'StartDate-' + index} isRight={startValue.format('YY.MM.DD') === data.format('YY.MM.DD')} isLeft={endValue.format('YY.MM.DD') === data.format('YY.MM.DD')} isComprise={compriseDateList.includes(data.format('YY.MM.DD'))}>
                          <Date isClicked={data.format('YY.MM.DD') === startValue.format('YY.MM.DD') || data.format('YY.MM.DD') === endValue.format('YY.MM.DD')} isComprise={compriseDateList.includes(data.format('YY.MM.DD'))} onClick={() => dateClick('first', index)}>
                            {data.format('D')}
                          </Date>
                        </DateWrapper>
                        :
                        <WithoutHoverDate key={'StartDate-' + index}>
                          {data.format('D')}
                        </WithoutHoverDate>
                    ))
                  }
                </TotalDateWrapper>
              </CalenderView>
            </CalenderWrapper>
            <CalenderWrapper>
              <InputWrapper>
                <Text>{t('statistics.calendar.endDate')}</Text>
                <Input img={CalenderImagePath}>
                  {formatMomentDate(endValue)}
                  {
                    endValue.format('YYYY.MM.DD') !== '2000.01.01' &&
                    <CalenderExit onClick={() => onClickCalenderExit('end')} />
                  }
                </Input>
              </InputWrapper>
              <CalenderView>
                <CalenderTitleWrapper>
                  <Arrow img={CalenderLeftArrow2ImagePath} onClick={() => setToday(today.clone().subtract(1, 'year'))} style={{ margin: `0 -7px 0 0` }} />
                  <Arrow img={leftArrowImage} onClick={() => setToday(today.clone().subtract(1, 'month'))} />
                  <Title>{today.clone().add(1, 'month').format(t('statistics.dateFormatMonth'))}</Title>
                  <Arrow img={rightArrowImage} onClick={() => setToday(today.clone().add(1, 'month'))} />
                  <Arrow img={CalenderRightArrow2ImagePath} onClick={() => setToday(today.clone().add(1, 'year'))} style={{ margin: `0 0 0 -7px` }} />
                </CalenderTitleWrapper>
                <DateColumnWrapper>
                  <DateColumn style={{ width: `25px`, marginRight: `36px` }}>SUN</DateColumn>
                  <DateColumn style={{ width: `30px`, marginRight: `34px` }}>MON</DateColumn>
                  <DateColumn style={{ width: `23px`, marginRight: `36px` }}>TUE</DateColumn>
                  <DateColumn style={{ width: `28px`, marginRight: `35px` }}>WED</DateColumn>
                  <DateColumn style={{ width: `25px`, marginRight: `42px` }}>THU</DateColumn>
                  <DateColumn style={{ width: `18px`, marginRight: `40px` }}>FRI</DateColumn>
                  <DateColumn style={{ width: `24px`, marginRight: `28px` }}>SAT</DateColumn>
                </DateColumnWrapper>
                <TotalDateWrapper>
                  {
                    endDateList.map((data, index) => (
                      data.format('MM') === today.clone().add(1, 'month').format('MM') ?
                        <DateWrapper key={'EndDate-' + index} isRight={startValue.format('YY.MM.DD') === data.format('YY.MM.DD')} isLeft={endValue.format('YY.MM.DD') === data.format('YY.MM.DD')} isComprise={compriseDateList.includes(data.format('YY.MM.DD'))}>
                          <Date isClicked={startValue.format('YY.MM.DD') === data.format('YY.MM.DD') || endValue.format('YY.MM.DD') === data.format('YY.MM.DD')} isComprise={compriseDateList.includes(data.format('YY.MM.DD'))} onClick={() => dateClick('second', index)}>
                            {data.format('D')}
                          </Date>
                        </DateWrapper>
                        :
                        <WithoutHoverDate key={'EndDate-' + index}>
                          {data.format('D')}
                        </WithoutHoverDate>
                    ))
                  }
                </TotalDateWrapper>
              </CalenderView>
            </CalenderWrapper>
          </InfoWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickExitButton}>{t('statistics.calendar.cancel')}</ExitButton>
            <SaveButton onClick={onClickSave}>
              <CustomText fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='pointer'>{t('statistics.calendar.apply')}</CustomText>
            </SaveButton>
          </ButtonWrapper>
        </InnerWrapper>
      </Modal>
    </TotalModalWrapper>
  )
}

const Modal = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1002px;
  height: 670px;

  border-radius: 30px;
  background-color: ${props => props.theme.subBackground};
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 94%;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  margin-top: 14px;

  gap: 32px;

  height: 514px;
`;

const CalenderWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;

  margin-bottom: 16px;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const Input = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 179px;
  height: 30px;

  margin-top: 8px;
  padding-left: 40px;
  padding-right: 6px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;

  background: url(${props => props.img}) no-repeat 10px center;
  background-color: ${props => props.disabled ? props.theme.buttonFill : props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.gray};

  transition: all 0.2s ease-in-out;
`;

const CalenderView = styled.div`
  display: flex;
  flex-direction: column;

  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const CalenderTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin: 28px 0 0 22px;
`;

const Arrow = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  
  background: url(${props => props.img}) no-repeat center center;

  &:hover {
    cursor: pointer;
  }
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const DateColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: 29px;
  margin-left: 28px;
  margin-bottom: 23px;
`;

const DateColumn = styled.p`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  font-family: Poppins-bold;
  font-size: 12px;

  color: ${props => props.theme.brand500};

  margin: 0 0 0 0;
`;

const TotalDateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  width: 448px;
  margin-left: 8px;
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  padding: 0 7px 0 7px;

  margin: ${props => props.isRight ? `0 0 8px 7px` : props.isLeft ? `0 7px 8px 0` : `0 0 8px 0`};
  padding: ${props => props.isRight ? `0 7px 0 0` : props.isLeft ? `0 0 0 7px` : `0 7px 0 7px`};

  border-radius: ${props => props.isRight ? `48px 0 0 48px` : props.isLeft ? `0 48px 48px 0` : `0 0 0 0`};
  background-color: ${props => props.isComprise ? props.theme.brand500Alpha5 : props.theme.subBackground};
`;

const Date = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  border-radius: 48px;

  background-color: ${props => props.isClicked ? props.theme.brand500 : props.isComprise ? 'transparent' : props.theme.subBackground};

  font-family: Poppins-Medium;
  font-size: 14px;

  color: ${props => props.isClicked ? props.theme.white : props.theme.subText};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.brand500};
    color: ${props => props.theme.white};

    font-family: Poppins-Bold;
    font-size: 14px;
  }
`;

const WithoutHoverDate = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  border-radius: 48px;

  margin: 0 7px 5px 7px;

  background-color: ${props => props.theme.subBackground};

  font-family: Poppins-Regular;
  font-size: 14px;

  color: ${props => props.theme.historyText};

  &:hover {
    cursor: default;
  }
`;

const CalenderExit = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  position: relative;

  width: 20px;
  height: 20px;

  border-radius: 50%;
  background-color: ${props => props.theme.brand500};

  &:hover {
    cursor: pointer;
  }

  &::before,
  &::after {
    content: '';

    position: absolute;

    width: 10px;
    height: 2px;

    border-radius: 2px;
    background-color: #000000;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

const CustomText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 28px;

  width: 100%;

  gap: 16px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 38px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 15px;
  background-color: ${props => props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.gray};

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.subText};
    border: 1px solid ${props => props.theme.subText};
  }

  transition: all 0.3s ease-in-out;
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 98px;
  height: 38px;

  border-radius: 15px;
  background-color: ${props => props.theme.subKey};

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKeyHover};
  }

  transition: all 0.3s ease-in-out;
`;